import type { UsersNeedingAction } from "@/lib/api_client";

/** Only companies behind pending blood tests belong in the blood-test overview. */
export function bloodTestCompanyNames(
  actions: Pick<UsersNeedingAction, "status" | "companyName">[],
): string[] {
  const companyNames = new Set<string>();
  for (const action of actions) {
    if (action.status === "bloodTestRequested" && action.companyName) {
      companyNames.add(action.companyName);
    }
  }
  return [...companyNames];
}

export function surveyCompletionLabel(completed: boolean | null | undefined): string {
  return completed == null ? "—" : completed ? "Fullført" : "Ikke fullført";
}
